/* global window */

import Vue from 'vue';

// Components
import QdAppsOverview from '../../apps-overview/apps-overview.js';

// Mixins
import { RestComponent } from '../../../mixins/rest-component';

// Template and media files
import template from './page-default.vhtml';

export const PageDefault = Vue.component( 'page-default', {
	components: {
		QdAppsOverview,
	},
	mixins: [
		RestComponent,
	],
	template: template,
	props: {
		postId: Number,
	},
	data: () => ({}),
	watch: {
		content() {
			this.$store.commit('apps/setupData', this.content);
		},
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
	},
});


// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-default/page-default.js